export default __webpack_public_path__ + "static/natasha1-f37482a9ad64e6e792f721af8faf0986.jpg";